<template>
	<label
		:class="[{ 'mb-1': !inline }, `absolute text-${color}`]"
		:style="{ left: '0', top: '-16px' }"
		v-bind="$attrs"
	>
		<slot></slot>
	</label>
</template>

<script>
	export default {
		name: 'AppLabel',
		props: {
			color: {
				type: String,
				default: 'secondary',
			},
			inline: {
				type: Boolean,
				default: false,
			},
		},
	};
</script>

<style scoped>
	label {
		@apply text-13 leading-3;
	}
</style>
